var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "loadingButton",
      class: {
        disabled: _vm.disabled,
        loading: _vm.loading,
        other_color: _vm.other_color,
      },
      on: { click: _vm.confirm },
    },
    [
      !_vm.loading ? _vm._t("default") : _vm._e(),
      _vm.loading
        ? _c("van-loading", {
            style: { color: _vm.other_color ? "#0c8027" : "#fff" },
            attrs: { size: "0.6rem" },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }